"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Span_sentrySpan;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Span = exports.InternalAttributes = void 0;
var InternalAttributes;
(function (InternalAttributes) {
    InternalAttributes["Sampled"] = "__sampled";
    InternalAttributes["IgnoreIfEmpty"] = "__ignoreIfEmpty";
})(InternalAttributes || (exports.InternalAttributes = InternalAttributes = {}));
class Span {
    static wrap(span) {
        return new Span(span);
    }
    constructor(span) {
        _Span_sentrySpan.set(this, void 0);
        __classPrivateFieldSet(this, _Span_sentrySpan, span, "f");
    }
    end() {
        __classPrivateFieldGet(this, _Span_sentrySpan, "f").end();
    }
    getAttribute(key) {
        // TODO: This is deprecated and should be replaced with getSpanAttributes(), but that
        // doesn't appear to exist yet.
        return __classPrivateFieldGet(this, _Span_sentrySpan, "f").attributes[key];
    }
    setAttribute(key, value) {
        __classPrivateFieldGet(this, _Span_sentrySpan, "f").setAttribute(key, value);
    }
    setInternalAttributes(spanOpts) {
        var _a, _b, _c;
        this.setAttribute(InternalAttributes.Sampled, (_a = spanOpts.sampled) !== null && _a !== void 0 ? _a : true);
        this.setAttribute(InternalAttributes.IgnoreIfEmpty, (_b = spanOpts.ignoreIfEmpty) !== null && _b !== void 0 ? _b : false);
        for (const [key, value] of Object.entries((_c = spanOpts.attributes) !== null && _c !== void 0 ? _c : {})) {
            if (value !== undefined) {
                this.setAttribute(key, value);
            }
        }
    }
    getSampled() {
        var _a;
        return (_a = this.getAttribute(InternalAttributes.Sampled)) !== null && _a !== void 0 ? _a : false;
    }
    setSampled(sampled) {
        this.setAttribute(InternalAttributes.Sampled, sampled);
    }
    getTraceId() {
        return __classPrivateFieldGet(this, _Span_sentrySpan, "f").spanContext().traceId;
    }
}
exports.Span = Span;
_Span_sentrySpan = new WeakMap();
//# sourceMappingURL=Span.js.map